export default {
  path: '/material_feed_specs',
  name: 'material_feed_specs',
  component: () => import('../components/materialfeedspec/Layout'),
  redirect: { name: 'MaterialFeedSpecList' },
  meta: {
    breadcrumb: 'profile.material.feedspecs',
  },
  children: [
    {
      name: 'MaterialFeedSpecList',
      path: '',
      component: () => import('../views/materialfeedspec/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialFeedSpecCreate',
      path: 'new',
      component: () => import('../views/materialfeedspec/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialFeedSpecUpdate',
      path: ':id/edit',
      component: () => import('../views/materialfeedspec/Update'),
      meta: {
        breadcrumb: 'profile.material.feedspec',
      },
    },
    {
      name: 'MaterialFeedSpecShow',
      path: ':id',
      component: () => import('../views/materialfeedspec/Show'),
      meta: {
        breadcrumb: 'profile.material.feedspec',
      },
    }
  ]
};
